import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';
import PageHeader from '@/components/Layout/PageHeader';
import SettingsNav from './SettingsNav';

const SettingsHeader = (): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <div className="relative min-h-screen">
        <Helmet>
          <title>LuckyDays - {intl.formatMessage({ id: 'settings.header' })}</title>
        </Helmet>
        <PageHeader>
          <h1>{intl.formatMessage({ id: 'settings.header' })}</h1>
          <p>{intl.formatMessage({ id: 'settings.subHeader' })}</p>
        </PageHeader>
        <SettingsNav />
        <div className="content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default SettingsHeader;
